
<div class="bi-actions">
  <div v-for="action in getActions" :key="action.id">
    <BoardItemAction :action="action" :boardId="item.ownerBoardId"></BoardItemAction>
  </div>
</div>
